import React from 'react';

import './styles.css';

export interface ConfirmDialogProps{
  opened: boolean;
  onSubmit: () => void;
  onClose: () => void;
  title: string;
  description: string;
  warning?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
    opened,
    onSubmit,
    onClose,
    title,
    description,
    warning
  }) => {
    return (
      <>
        {opened && (
          <div className="loading-overlay">
            <div className="dialog-container">
              <header>{title}</header>
              <div className="dialog-content-container">
                <div className="dialog-content">
                  <p>{description}</p>
                  {warning && warning.length > 0 && <i>{warning}</i>}
                </div>
                <div className="container-buttons">
                  <button type="button" onClick={onClose}>Não</button>
                  <button type="button" onClick={onSubmit}>Sim</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    )    
}

export default ConfirmDialog;